import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <circle cx="12" cy="12" r="12" />
    <path
      d="M12 6.75C11.7864 6.75 11.5815 6.83487 11.4304 6.98594C11.2793 7.13701 11.1944 7.34191 11.1944 7.55556V11.1944H7.55556C7.34191 11.1944 7.13701 11.2793 6.98594 11.4304C6.83487 11.5815 6.75 11.7864 6.75 12C6.75 12.2136 6.83487 12.4185 6.98594 12.5696C7.13701 12.7207 7.34191 12.8056 7.55556 12.8056H11.1944V16.4444C11.1944 16.6581 11.2793 16.863 11.4304 17.0141C11.5815 17.1651 11.7864 17.25 12 17.25C12.2136 17.25 12.4185 17.1651 12.5696 17.0141C12.7207 16.863 12.8056 16.6581 12.8056 16.4444V12.8056H16.4444C16.6581 12.8056 16.863 12.7207 17.0141 12.5696C17.1651 12.4185 17.25 12.2136 17.25 12C17.25 11.7864 17.1651 11.5815 17.0141 11.4304C16.863 11.2793 16.6581 11.1944 16.4444 11.1944H12.8056V7.55556C12.8056 7.34191 12.7207 7.13701 12.5696 6.98594C12.4185 6.83487 12.2136 6.75 12 6.75Z"
      fill="white"
      stroke="white"
      strokeWidth="0.3"
    />
  </>,
  'PlusInvertIcon',
)
